(function () {
  const STORAGE_KEY = 'recently_viewed_products';

  const section = document.querySelector('[data-recent-section]');
  if (!section) return;

  const slider = section.querySelector('[data-recent-slider]');
  if (!slider) return;

  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (e) {
    items = [];
  }

  if (!items.length) {
    section.style.display = 'none';
    return;
  }

  const limit = parseInt(slider.dataset.limit || 8, 10);
  const handles = items.slice(0, limit).map(p => p.handle);

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return 'Rp' + (cents / 100).toLocaleString('id-ID');
    }
  };

  handles.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const card = document.createElement('div');
        card.className = 'card-item-compact';

        const showCompare =
            product.compare_at_price &&
            product.compare_at_price > product.price;

        card.innerHTML = `
            <a href="${product.url}" class="img-wrap">
            <img
              src="${product.featured_image}"
              alt="${product.title}"
              loading="eager"
              fetchpriority="high"
            />
            </a>
            <div class="info-wrap">
             <div class="info-wrap">
                <div class="product-vendor">
                ${ product.vendor }
              </div>
            <a href="${product.url}" style="text-decoration:none">
                <div class="product-desc">${product.title}</div>
            </a>
            <div class="price-container">
                <span class="price-bold">${formatMoney(product.price)}</span>
                ${
                showCompare
                    ? `<span class="price-compare">${formatMoney(product.compare_at_price)}</span>`
                    : ``
                }
            </div>
            </div>
        `;

        slider.appendChild(card);
    });

  });
})();
